import type { FC } from 'react';
import type { VolSurfaceTimeseriesProps } from './types';
import VolSurfaceTimeseriesWidget from './vol-surface-timeseries-widget';
import { TimeseriesProvider } from '../../../../providers/timeseries-provider';

const VolSurfaceTimeseriesWrapperProvider: FC<VolSurfaceTimeseriesProps> = (props) => (
  <TimeseriesProvider providerKey={props.providerKey}>
    <VolSurfaceTimeseriesWidget {...props} />
  </TimeseriesProvider>
);

export default VolSurfaceTimeseriesWrapperProvider;
